function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  y2: 1.07493,
  x2: 0.10946,
  y1: 0.47364,
  x1: 0.56818,
  id: "paint0_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ABABAB"
}), /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.49603,
  stopColor: "#BDBCBC",
  offset: 0.66165
}), /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0,
  stopColor: "#ABABAB",
  offset: 1
})));

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  id: "canvas_background",
  height: 22,
  width: 22,
  y: -1,
  x: -1
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  id: "svg_1",
  fill: "url(#paint0_linear)",
  d: "m14.04,0.11331l-8.08001,0c-1.58069,0 -3.09663,0.62152 -4.21434,1.7278c-1.11772,1.10627 -1.74565,2.60666 -1.74565,4.17116l0,7.99727c0,1.56449 0.62793,3.06496 1.74565,4.17129c1.11771,1.10623 2.63365,1.72773 4.21434,1.72773l8.08001,0c1.5807,0 3.0967,-0.62149 4.2144,-1.72773c1.1177,-1.10633 1.7456,-2.60681 1.7456,-4.17129l0,-7.99727c0,-1.5645 -0.6279,-3.06489 -1.7456,-4.17116c-1.1177,-1.10627 -2.6337,-1.7278 -4.2144,-1.7278zm3.9438,13.89298c0,1.03521 -0.4155,2.02802 -1.1551,2.7601c-0.7396,0.73198 -1.7427,1.14326 -2.7887,1.14326l-8.08001,0c-1.04597,0 -2.0491,-0.41129 -2.78871,-1.14326c-0.7396,-0.73208 -1.15509,-1.72488 -1.15509,-2.7601l0,-7.99732c0,-1.03526 0.41549,-2.02816 1.15509,-2.7602c0.73961,-0.73203 1.74274,-1.14329 2.78871,-1.14329l8.08001,0c1.046,0 2.0491,0.41127 2.7887,1.14329c0.7396,0.73204 1.1551,1.72495 1.1551,2.7602l0,7.99732zm-2.6987,-8.06356c0.6847,0 1.2397,-0.54935 1.2397,-1.22702c0,-0.67766 -0.555,-1.22701 -1.2397,-1.22701c-0.6846,0 -1.2396,0.54935 -1.2396,1.22701c0,0.67767 0.555,1.22702 1.2396,1.22702zm-8.15923,-0.1906c0.85018,-0.56226 1.84971,-0.86236 2.87221,-0.86236c1.37062,0.00179 2.68452,0.54145 3.65372,1.50067c0.9691,0.95923 1.5144,2.25974 1.5162,3.61631c0,1.01198 -0.3033,2.00134 -0.8713,2.84278c-0.5681,0.84144 -1.3755,1.49723 -2.3202,1.88457c-0.9447,0.38724 -1.98414,0.48869 -2.98699,0.29127c-1.00286,-0.19753 -1.92405,-0.6848 -2.64707,-1.40044c-0.72302,-0.71554 -1.2154,-1.62739 -1.41488,-2.61999c-0.19948,-0.9925 -0.09711,-2.02135 0.29418,-2.95634c0.3913,-0.935 1.05395,-1.73421 1.90413,-2.29646zm1.11747,6.85594c0.51942,0.34352 1.13007,0.52684 1.75474,0.52684l0,0.00497c0.41542,0 0.82672,-0.08106 1.21042,-0.23861c0.3837,-0.15755 0.7322,-0.38846 1.0256,-0.67942c0.2934,-0.29107 0.526,-0.63651 0.6843,-1.01655c0.1583,-0.38014 0.2394,-0.78747 0.2385,-1.19855c-0.0004,-0.61831 -0.1859,-1.22266 -0.5332,-1.73657c-0.3473,-0.51392 -0.8408,-0.91432 -1.418,-1.1507c-0.5772,-0.23638 -1.21227,-0.29808 -1.82491,-0.17725c-0.61263,0.12082 -1.1753,0.41877 -1.6169,0.85608c-0.44159,0.43731 -0.74228,0.99433 -0.86403,1.60076c-0.12174,0.60646 -0.05909,1.23495 0.18004,1.80623c0.23913,0.57117 0.64402,1.05936 1.16344,1.40277z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}));

const SvgIconInstagramDisabled = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconInstagramDisabled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-instagram-disabled.abfa39bd.svg";
export { ForwardRef as ReactComponent };